export default {
  default: () => import("/codebuild/output/src759720886/src/src/layouts/default.vue").then(m => m.default || m)
}